<!--
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2025-10-22 15:50:48
 * @LastEditors: ankeji
 * @LastEditTime: 2025-11-17 09:12:20
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    title="如何获取Session ID"
    width="80%"
    :before-close="handleClose"
  >
    <div class="method-container">
      <el-tabs v-model="activeTab">
        <!-- 自行获取方式 -->
        <el-tab-pane label="自行获取" name="manual">
          <div class="method-content">
            <h3>步骤说明：</h3>
            <ol>
              <li>
                打开浏览器，访问
                <el-link
                  type="primary"
                  href="https://www.douyin.com"
                  target="_blank"
                  >DYin官网</el-link
                >
              </li>
              <li>登录你的DYin账号，登录DYin账号</li>
              <li>在登录完DYin账号的网页下，按键盘 F12 打开开发者工具</li>
              <li>点击 Application（应用程序）选项卡</li>
              <li>在下方左侧列表中找到Cookie行</li>
              <li>
                在右侧表格中找到为 "sessionid" 的值（<font color="red"
                  >不会操作的下图有教程</font
                >）<font color="red"
                  >Session ID 有时效性，过期后需要重新登录获取</font
                >
              </li>
              <div>
                <h2>Edge 浏览器教程</h2>
                <img
                  style="width: 100%"
                  src="../assets/PixPin_2025-10-22_16-07-14.png"
                  alt=""
                />
              </div>
              <div>
                <h2>谷歌浏览器教程</h2>
                <img
                  style="width: 100%"
                  src="../assets/PixPin_2025-10-22_16-16-46.png"
                  alt=""
                />
              </div>
            </ol>
            <el-alert
              title="注意事项"
              type="warning"
              :closable="false"
              show-icon
            >
              <template #default>
                <ul>
                  <!-- <li>Session ID 是敏感信息，请妥善保管</li> -->
                  <li>Session ID 有时效性，过期后需要重新获取</li>
                  <!-- <li>不要在不信任的网站输入你的 Session ID</li> -->
                </ul>
              </template>
            </el-alert>
          </div>
        </el-tab-pane>

        <!-- 插件获取方式 -->
        <el-tab-pane label="插件获取" name="plugin">
          <div class="method-content">
            <h3>安装步骤：</h3>
            <ol>
              <li>点击下方下载插件按钮</li>
              <li>解压下载后的插件文件【文件名：session-id-helper.zip】</li>
              <li>打开Chrome浏览器或者Edge浏览器，进入扩展程序页面</li>
              <div>谷歌浏览器打开拓展在浏览器网址输入框输入：chrome://extensions/</div>
              <div>Edge浏览器打开拓展在浏览器网址输入框输入：edge://extensions/</div>
              <li>开启"开发者模式"（<font color="red">不会操作的下图有教程</font>）</li>
              <li>点击"加载已解压的扩展程序"（<font color="red">不会操作的下图有教程</font>）</li>
              <li>选择已解压的插件文件夹session-id-helper</li>
              <li>安装好的样子（不显示右上角的按钮就是开发者模式没有打开，开第4步）</li>
              <img style="width: 500px;" src="../assets/huoquchajian.png" alt="">
            </ol>
            <div class="plugin-buttons">
              <el-button type="primary" @click="downloadPlugin"
                >复制插件下载地址</el-button
              >
              <!-- <el-button @click="openExtensionPage"
                >去下载插件（只支持Edge浏览器，谷歌浏览器点击左侧下载插件按钮自行下载）</el-button
              > -->
            </div>
            <el-alert title="常见问题" type="info" :closable="false" show-icon>
              <template #default>
                <div>
                  <h2 style="text-align: left; color: #333">
                    Edge浏览器开启"开发者模式"
                  </h2>
                  <img
                    style="width: 100%"
                    src="../assets/PixPin_2025-10-22_16-50-37.png"
                    alt=""
                  />
                </div>
                <div>
                  <h2 style="text-align: left; color: #333">
                    Edge浏览器加载已解压的扩展程序教程
                  </h2>
                  <img
                    style="width: 100%"
                    src="../assets/ScreenShot_2025-10-24_103430_071.png"
                    alt=""
                  />
                </div>
                <div>
                  <h2 style="text-align: left; color: #333">
                    谷歌浏览器开启"开发者模式"
                  </h2>
                  <img
                    style="width: 100%"
                    src="../assets/PixPin_2025-10-22_16-55-46.png"
                    alt=""
                  />
                </div>
                <div>
                  <h2 style="text-align: left; color: #333">
                    谷歌浏览器浏览器加载已解压的扩展程序教程
                  </h2>
                  <img
                    style="width: 100%"
                    src="../assets/gugetuozhan.png"
                    alt=""
                  />
                </div>
              </template>
            </el-alert>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";

const dialogVisible = ref(false);
const activeTab = ref("manual");

const open = () => {
  dialogVisible.value = true;
};

const handleClose = () => {
  dialogVisible.value = false;
};

const downloadPlugin = async () => {
  const url = "https://mp-54d25869-6f9e-4a94-ae8f-388997b47956.cdn.bspapp.com/session-id-helper.zip";
  try {
    await navigator.clipboard.writeText(url);
    ElMessage.success('插件下载地址已复制到剪贴板，请手动粘贴到浏览器地址栏下载');
  } catch (err) {
    // 降级方案
    const textArea = document.createElement('textarea');
    textArea.value = url;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    ElMessage.success('插件下载地址已复制到剪贴板，请手动粘贴到浏览器地址栏下载');
  }
};


const openExtensionPage = () => {
  // 检测浏览器类型
  const isEdge = navigator.userAgent.includes("Edg/");
  if (isEdge) {
    window.open(
      `https://microsoftedge.microsoft.com/addons/search/FeHelper?hl=zh-CN&filteredAddon=1&filterFeaturedAddons=false&filteredRating=0&sortBy=Relevance`,
      "_blank"
    );
  } else {
    ElMessageBox.alert(
      "由于外网限制，谷歌浏览器请【下载插件】自行安装",
      "提示",
      {
        confirmButtonText: "我知道了",
        type: "warning",
      }
    );
  }
};

defineExpose({
  open,
});
</script>

<style scoped>
.method-container {
  padding: 20px;
}

.method-content {
  line-height: 1.6;
}

.method-content h3 {
  margin-bottom: 15px;
  color: #409eff;
}

.method-content ol {
  padding-left: 20px;
  margin-bottom: 20px;
  text-align: justify;
}

.method-content li {
  margin-bottom: 10px;
  text-align: justify;
}

.plugin-buttons {
  margin: 20px 0;
  display: flex;
  gap: 10px;
}

.el-alert {
  margin-top: 20px;
}

.el-alert ul {
  margin: 0;
  padding-left: 20px;
}

.el-alert li {
  margin-bottom: 5px;
}
</style>
